import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Zoom from "@mui/material/Zoom";
import { useDispatch, useSelector } from "react-redux";
import { getMoreInfo } from "../../Redux/MoreInfo/moreInfoSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as ClipBoard } from "../../assets/Icons/clipBoard.svg";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { checkOperatingSystem, convertDateAndTimeToLocal, getEventInfo, imageUrlCheck } from "../../utils/utils";
import { ReactComponent as PlayIcon } from "../../assets/Icons/play.svg";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import { ReactComponent as ShareIcon } from "../../assets/Icons/share.svg";

import parse from "html-react-parser";
import MainLoading from "../../Components/Loading/MainLoading";
import { authenticate } from "../../network/service";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import { useRef as useReactRef } from "react";
import { useWindowWidth } from "@react-hook/window-size";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getMoreInfoOther } from "../../Redux/MoreInfo/moreInfoOtherSlice";
import TrailerModal from "../../Components/Modals/TrailerModal";
import LogoutAllModal from "../../Components/Modals/LogoutAllModal";
import { getEventMoreInfo } from "../../Redux/MoreInfo/eventMoreInfoSlice";
import Translate from "../../Components/MultiLanguage/Translate";
import { toast } from 'react-toastify';
import { getDownloadProgress } from "../../Redux/DownloadB2BSlice/DownloadB2bSlice";
import {downloadPlaylist, getB2BDetails, updateB2BViewCOunt, getVideoDetails} from "./service";
import { ReactComponent as InfoIcon } from "../../assets/Icons/info.svg";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom direction="down" ref={ref} {...props} />;
});
const B2BDetailsScreenModal = ({ fetchHomeData, modalShow }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);
  const isEventMoreInfo = useSelector((state) => state?.eventMoreInfo?.value);
  const downloadB2bModal = useSelector((state) => state?.downloadB2bModal?.value);

  const isMoreInfo = useSelector((state) => state?.overlay?.value);
  const [showDetails, setShowDetails] = useState({});
  const [playerToken, setPlayerToken] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedVideoDetails, setSelectedVideoDetails] = useState();
  const [videoPlayer, setVideoPlayer] = useState();
  const [multiLanguageOptions, setMultiLanguageOptions] = useState([]);
  const [selectedAudioLanguage, setSelectedAudioLanguage] = useState(null);
  const videoJsPlayerRef = useReactRef();
  const [trailerUrl, setTrailerUrl] = useState("");
  const [isTrailer, setIsTrailer] = useState(false);
  const [open, setOpen] = useState(false);
  const [pageURL, setPageURL] = useState("");
  const [isShareActive, setIsShareActive] = useState(false);
  const [b2bMessage, setB2BMessage] = useState("");
  const [isShowDownload, setIsShowDownload] = useState(false);
  const [isShowDownloadRight, setIsShowDownloadRight] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [invalidURL, setInvalidURL] = useState(false);
  const [isShowDownloadLeft, setIsShowDownloadLeft] = useState(false);

  const windowSize = useWindowWidth();
  const scrollRef = useRef(null);
  const shareRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const { eventId } = useParams();
  const navigate = useNavigate();
  let eventUniqueId = isEventMoreInfo?.eventId ? isEventMoreInfo?.eventId : eventId;
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    if (videoPlayer && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [videoPlayer]);

  useEffect(() => {

    setPageURL(window.location.href);

    return () => {
      handleReset();
    };
  }, []);
  useEffect(() => {
    if (location?.pathname === "/home") {
      handleClose();
    }
  }, [location?.pathname]);

  useEffect(() => {
    if (isMoreInfoOther?.eventId) {
      eventUniqueId = isMoreInfoOther?.eventId;
    }
  }, [isMoreInfoOther?.eventId]);

  useEffect(() => {
    window.scroll(0, 0);
    if (location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByB2bURL(vanityUrl);
        setOpen(true);
      } else {
        if (eventUniqueId) {
          setOpen(true);
          if (eventUniqueId !== "null" && eventUniqueId !== "undefined") {
            fetchEventInfo();
          }
        }
      }
    }
  }, [accessToken, projectInfo, location?.pathname]);

  useEffect(() => {
    setVideoPlayer(null);
    if (videoUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${videoUrl}`,
            type: "application/x-mpegURL",
          },
        ],
      };
      setLoading(false);
      setVideoPlayer(
        <VideoJS
          options={videoJsOptions}
        />
      );
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [videoUrl]);

  useEffect(() => {
    setVideoPlayer(null);
    if (trailerUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${trailerUrl}`,
            type: "application/x-mpegURL",
          },
        ],
      };
      setVideoPlayer(
        <VideoJS
          options={videoJsOptions}
        />
      );
      setLoading(false);
    }
  }, [trailerUrl]);

  const isValidImageUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
    const lowerUrl = url.toLowerCase();
    return validExtensions.some(ext => lowerUrl.endsWith(ext));
  };


  const watchVideoHandler = async () => {
    if (showDetails?.type === "TRAILER" && showDetails?.teaser) {
      setIsTrailer(true);
      if (showDetails?.b2b_id) {
        await updateViewCount(showDetails.b2b_id);
      }
      await fetchPlayerTokenTrailer(showDetails);
    } else if (showDetails?.type === "PLAYLIST" && showDetails?.videos && showDetails?.videos[0]) {
      await playVideo(showDetails?.videos[0]);
    } else if (showDetails?.single_video === 1 && showDetails?.videos && showDetails?.videos[0]) {
      await playVideo(showDetails?.videos[0]);
    } else if (showDetails?.videos && showDetails?.videos[0]) {
      await playVideo(showDetails?.videos[0]);
    } else {
      handleClose();
    }
  };

  useEffect(() => {
    if (videoUrl) {
      if (videoJsPlayerRef.current && typeof videoJsPlayerRef.current.dispose === "function") {
        videoJsPlayerRef.current.dispose();
        videoJsPlayerRef.current = null;
      }
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${videoUrl}`,
            type: "application/x-mpegURL",
          }
        ]
      };
      setLoading(false);
      setVideoPlayer(
        <VideoJS key={videoUrl} options={videoJsOptions} />
      );
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [videoUrl]);

  const playVideo = async (videoDetails) => {
    try {
      setVideoPlayer(null);
      setVideoUrl("");
      setSelectedVideoDetails(videoDetails);
      setShowDownload(true);
      let playerTokenData;
      let videoId;
      let url;
      let audio = null;
      if (videoDetails?.audio_languages && Array.isArray(videoDetails.audio_languages) && videoDetails.audio_languages.length > 1) {
        setMultiLanguageOptions(videoDetails.audio_languages);
        if (videoDetails.selectedAudioLanguage) {
          setSelectedAudioLanguage(videoDetails.selectedAudioLanguage);
          audio = videoDetails.selectedAudioLanguage.audio;
        } else {
          setSelectedAudioLanguage({
            value: videoDetails.audio_languages[0].language_name,
            label: videoDetails.audio_languages[0].language_name,
            video_time: videoDetails.audio_languages[0].video_time,
            audio: videoDetails.audio_languages[0].audio
          });
          audio = videoDetails.audio_languages[0].audio;
        }
      } else {
        setMultiLanguageOptions([]);
        setSelectedAudioLanguage(null);
      }
      if (showDetails?.type !== "TRAILER") {
        videoId = videoDetails?.video_id;
        const videoDetailsResponse = await getVideoDetails(videoId, appInfo, showDetails?.b2b_id);
        let playlistId = videoId;
        if (videoDetailsResponse?.status === 200 && videoDetailsResponse?.data?.data) {
          setSelectedVideoDetails(videoDetailsResponse.data.data);
          playlistId = videoDetailsResponse.data.data.video_time || videoDetailsResponse.data.data.video_id || videoId;
          if (videoDetailsResponse.data.data.audio_languages && Array.isArray(videoDetailsResponse.data.data.audio_languages) && videoDetailsResponse.data.data.audio_languages.length > 1) {
            setMultiLanguageOptions(videoDetailsResponse.data.data.audio_languages);
            if (videoDetails.selectedAudioLanguage) {
              setSelectedAudioLanguage(videoDetails.selectedAudioLanguage);
              audio = videoDetails.selectedAudioLanguage.audio;
            } else {
              setSelectedAudioLanguage({
                value: videoDetailsResponse.data.data.audio_languages[0].language_name,
                label: videoDetailsResponse.data.data.audio_languages[0].language_name,
                video_time: videoDetailsResponse.data.data.audio_languages[0].video_time,
                audio: videoDetailsResponse.data.data.audio_languages[0].audio
              });
              audio = videoDetailsResponse.data.data.audio_languages[0].audio;
            }
          } else {
            setMultiLanguageOptions([]);
            setSelectedAudioLanguage(null);
            audio = null;
          }
        }
        playerTokenData = await fetchPlayerToken(playlistId);
        updateViewCount(showDetails.b2b_id);
        if (playerTokenData) {
          url = `https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=${playlistId}&token=${playerTokenData}&type=video&pubid=${projectInfo?.projectConfig?.pubid}`;
          if (audio) {
            url += `&audio=${audio}`;
          }
          if (showDetails?.b2b_id) {
            url += `&b2b_id=${showDetails?.b2b_id}`;
          }
          setVideoUrl(url);
        }
      } else {
        const videoName = videoDetails?.video_name || videoDetails?.video_title;
        const arr = videoName?.split("/").reverse();
        videoId = arr[1];
        playerTokenData = await fetchPlayerToken(videoId);
        updateViewCount(showDetails.b2b_id);
        if (playerTokenData) {
          url = `https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=${videoId}&token=${playerTokenData}&type=video&pubid=${projectInfo?.projectConfig?.pubid}`;
          if (audio) {
            url += `&audio=${audio}`;
          }
          if (showDetails?.b2b_id) {
            url += `&b2b_id=${showDetails?.b2b_id}`;
          }
          setVideoUrl(url);
        }
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const fetchPlayerToken = async (videoId) => {
    try {
      const { getPlayerToken } = await import("../../network/service");
      const playerTokenResponse = await getPlayerToken(appInfo, videoId);
      if (playerTokenResponse?.status === 200) {
        setPlayerToken(playerTokenResponse?.data?.data);
        return playerTokenResponse?.data?.data;
      }
    } catch (err) {
      return null;
    }
  };

  const fetchPlayerTokenTrailer = async (trailerDetails) => {
    let arr = trailerDetails.teaser?.split("/").reverse();
    const { getPlayerToken } = await import("../../network/service");
    const playerTokenResponse = await getPlayerToken(appInfo, arr[1]);
    if (playerTokenResponse?.status === 200) {
      if (trailerDetails?.b2b_id) {
        setTrailerUrl(
          `https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=${arr[1]}&token=${playerTokenResponse?.data?.data}&type=trailer&pubid=${appInfo?.projectDetails?.projectConfig?.pubid}&b2b_id=${trailerDetails?.b2b_id}`
        );
      } else {
        setTrailerUrl(
          `https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=${arr[1]}&token=${playerTokenResponse?.data?.data}&type=trailer&pubid=${appInfo?.projectDetails?.projectConfig?.pubid}`
        );
      }
    }
  };

  const fetchEventInfo = async () => {
    try{
      const response = await getEventInfo(appInfo,eventUniqueId);
      setShowDetails(response?.data?.data)
      setLoading(false)
    }catch(err){
      setLoading(false)
    }
  }

  const updateViewCount = async (id) => {
    await updateB2BViewCOunt(
      appInfo,
      id
    );
  }
 

  const handleClose = (type) => {
    document.body.className = "hideScroll";

    handleReset();
    setOpen(false);
    let path = location?.pathname
    if (path.split("/")[1]==="category") {
      setTimeout(() => {
        dispatch(
          getEventMoreInfo({
            isModal: false,
            eventId: null,
          })
        );
      }, 600);
    } else {
      if(type!=="showDetails"){
        navigate("/home");
      }
      setTimeout(() => {
        dispatch(
          getEventMoreInfo({
            eventMoreInfo: false,
          })
        );
      }, 500);
    }
    setTimeout(() => {
      setShowDetails(null);
    }, 600);
  };

  const handleReset = () => {
    setVideoPlayer(null);
    // setIsMute(false);
    // setVideoStarted(false);
  };


    const downloadPlaylistVideo = async (b2b_id, video_id, name) => {
      setIsShowDownload(false);
      setShowDownload(false);
      if (downloadB2bModal?.downloadProgress > 0) {
        toast('Download Already Exists!!', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
        setShowDownload(true);
        return;
      }
      try {
        const response = await downloadPlaylist(appInfo, b2b_id, video_id, name);
        const urlToDownload = response?.data?.data;
        if (!urlToDownload || response?.status !== 200) {
          toast('Error Occured!!', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1000,
          });
          setShowDownload(true);
          return;
        }
        const parsedUrl = new URL(urlToDownload);
        const filename = decodeURIComponent(parsedUrl.pathname.split('/').pop());
        toast('Download Will Begin Shortly!!', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth',
        });
        const fileResponse = await fetch(urlToDownload, { method: "GET" });
        if (!fileResponse.ok) throw new Error("Network Error");
        const reader = fileResponse.body.getReader();
        const contentLength = +fileResponse.headers.get("Content-Length");
        let receivedLength = 0;
        const chunks = [];
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          receivedLength += value.length;
          dispatch(
            getDownloadProgress({
              downloadB2bModal: {
                showDownload: false,
                downloadProgress: ((receivedLength / contentLength) * 100).toFixed(2),
                filename: filename
              }
            })
          );
        }
        const blob = new Blob(chunks);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        toast.success('Download completed!', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
        });
        dispatch(
          getDownloadProgress({
            downloadB2bModal: {
              showDownload: true,
              downloadProgress: 0,
              filename: filename
            }
          })
        );
        setShowDownload(true);
      } catch (error) {
        console.error('Download Error:', error);
        toast('Error Occured!!', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
        setShowDownload(true);
      }
    };

  const redirectToLogin = () => {
    dispatch(
      getUser({
        user: null,
      })
    );
    localStorage.removeItem("userId");
    tokenAuthenticate();
    navigate("/login", {
      state: { path: location?.pathname, showId: eventUniqueId },
    });
  };

  const tokenAuthenticate = async () => {
    const response = await authenticate(appInfo);
    if (response?.status === 200) {
      dispatch(
        getAccessToken({
          accessToken: response?.data?.token,
        })
      );
    }
  };

    const fetchShowDetailsByB2bURL = async (b2bURL) => {
      try {
        setLoading(true);
        const b2bDetailsResponse = await getB2BDetails(
          appInfo,
          b2bURL
        );
        if (!b2bDetailsResponse || b2bDetailsResponse?.status !== 200 || b2bDetailsResponse?.data?.success === false) {
          setInvalidURL(true);
          setB2BMessage(b2bDetailsResponse?.data?.message || "No Data found!");
          setLoading(false);
          return;
        }
        if (b2bDetailsResponse?.data?.message !== "B2B url details") {
          setInvalidURL(true);
          setB2BMessage(b2bDetailsResponse?.data?.message || "No Data found!");
          setLoading(false);
          return;
        }
        if (b2bDetailsResponse?.status === 200) {
          const data = b2bDetailsResponse?.data?.data;
          if (data?.type === "TRAILER") {
            setShowDetails(data);
            setShowDownload(true);
            setLoading(false);
            return;
          }
          if (data?.sign_in_required) {
            if (data?.sign_in_required && data?.b2b_id) {
              setShowDetails(data);
              setLoading(false);
            } else {
              if (!user) {
                navigate("/login", { state: { path: location?.pathname } });
              } else {
                setInvalidURL(true);
                setB2BMessage(b2bDetailsResponse?.data?.message)
                setLoading(false);
              }
            }
          } else {
            if (b2bDetailsResponse?.data?.message === 'B2B url details') {
              setShowDetails(data);
              if (data?.type === "TRAILER") {
                setShowDownload(true);
              }
              setLoading(false);
            } else {
              setInvalidURL(true);
              setB2BMessage(b2bDetailsResponse?.data?.message)
              setLoading(false);
            }
          }
        }
      } catch (err) {
        setInvalidURL(true);
        setB2BMessage("No Data found!");
        setLoading(false);
      }
    };

  if (loading) {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        transitionDuration={600}
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="md"
        fullScreen={windowSize > 980 ? false : true}
      >
        <DialogContent sx={{ p: 0 }} dividers={false}>
          <MainLoading />
        </DialogContent>
      </Dialog>
    );
  }

  if (invalidURL && b2bMessage !== "B2B url details") {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        transitionDuration={600}
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="md"
        fullScreen={windowSize > 980 ? false : true}
      >
        <DialogContent sx={{ p: 0 }} dividers={false}>
          <div className="b2bdetailsScreenModal" ref={scrollRef}>
            <div className="b2b-warning" style={{margin: '40px', paddingTop: '60px', textAlign: 'center'}}>
              <InfoIcon />
              <div className="message" style={{fontSize: 20, color: '#fff'}}>
                {b2bMessage}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  const isPlaylist = showDetails?.type === "PLAYLIST" && Array.isArray(showDetails?.videos);

  const multiAudioDropdownHandler = async (selectedOption) => {
    setSelectedAudioLanguage({
      value: selectedOption.label,
      label: selectedOption.label,
      video_time: selectedOption.video_time,
      audio: selectedOption.audio
    });
    if (selectedVideoDetails) {
      await playVideo({ ...selectedVideoDetails, selectedAudioLanguage: selectedOption });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      transitionDuration={600}
      scroll={"body"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="md"
      fullScreen={windowSize > 980 ? false : true}
    >
      <DialogContent sx={{ p: 0 }} dividers={false}>
        <div className="b2bdetailsScreenModal" ref={scrollRef} onClick={() => setIsShareActive(false)}>
          {videoPlayer && <div className="videoPlayerTop">
            <div className="videoPlayerContainer">{videoPlayer}</div>
          </div>}
          <div className={`imgVideoContainer ${!isValidImageUrl(showDetails?.thumbnail_350_200 || showDetails?.logo || showDetails?.logo_thumb) || showDetails?.type === "TRAILER" ? "shrinked" : ""}`}>
            {multiLanguageOptions?.length > 1 && videoPlayer && (
              <div className="multiAudioSelectContainer">
                <Select
                  options={multiLanguageOptions.map((audio) => ({
                    value: audio.language_name,
                    label: audio.language_name,
                    video_time: audio.video_time,
                    audio: audio.audio
                  }))}
                  placeholder={multiLanguageOptions[0]?.language_name}
                  onChange={multiAudioDropdownHandler}
                  value={selectedAudioLanguage}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: '#232323',
                      borderColor: '#444',
                      color: '#fff',
                      minHeight: '38px',
                      boxShadow: 'none',
                      borderRadius: 'none',
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: '#fff',
                      fontWeight: 500,
                    }),
                    menu: (provided) => ({
                      ...provided,
                      backgroundColor: '#232323',
                      color: '#fff',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isSelected ? '#444' : state.isFocused ? '#333' : '#232323',
                      color: '#fff',
                      fontWeight: state.isSelected ? 600 : 400,
                      cursor: 'pointer',
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: '#fff',
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: '#bbb',
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      color: '#fff',
                    }),
                  }}
                />
              </div>
            )}
            <div className="closeButton">
              <button onClick={() => handleClose()}>
                <div className="icon">
                  <CloseIcon />
                </div>
              </button>
            </div>
            {(isValidImageUrl(showDetails?.thumbnail_350_200 || showDetails?.logo || showDetails?.logo_thumb)) && showDetails?.type !== "TRAILER" && (
                <img
                  className="show"
                  src={
                    isValidImageUrl(showDetails?.thumbnail_350_200)
                      ? showDetails?.thumbnail_350_200
                      : isValidImageUrl(showDetails?.logo)
                      ? showDetails?.logo
                      : showDetails?.logo_thumb
                  }
                  alt="Thumbnail"
                />
              )
            }
            <div className="showActions">
              <div className="b2b-warning">
                <div>
                  <svg height={20} width={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.25 13.5V8.25H12.75V13.5H11.25ZM11.25 15.75V14.25H12.75V15.75H11.25Z" fill="#fff"></path> </g></svg>
                </div>
                <div className="message">
                  <div>For Screening Purposes only.</div>
                  <div className="secondSentence">Not available for public viewing</div>
                </div>
              </div>
              <h1 className="title">{isPlaylist ? showDetails?.name : (showDetails?.show_name || showDetails?.title)}</h1>
              <div className="buttons">
                <div className="left">
                  {showDetails?.type !== "PLAYLIST" && (
                    <button className="play" onClick={watchVideoHandler}>
                      <div className="icon">
                        <PlayIcon />
                      </div>
                      <span><Translate textKey={'play'} /></span>
                    </button>
                  )}
                  {showDetails?.teaser_flag === 1 && showDetails?.teaser && (
                    <div className="trailerWatchNowButton" onClick={() => { setIsTrailer(true); fetchPlayerTokenTrailer(showDetails); }}>
                      <button>Trailer</button>
                    </div>
                  )}
                  {showDetails?.download_enabled && showDownload && (
                    <>
                      {showDetails?.type === "PLAYLIST" && Array.isArray(showDetails?.videos) && showDetails?.videos.length > 0 && (
                        <div className="downloadPlaylist">
                          <button
                            className="download-btn"
                            onClick={() => downloadPlaylistVideo(showDetails.b2b_id, showDetails.videos[0].video_id, "videoFlag")}
                          >
                            Download Playlist
                          </button>
                        </div>
                      )}
                      {showDetails?.type === "SHOW" && Array.isArray(showDetails?.videos) && showDetails?.videos.length > 0 && (
                        <div className="downloadShowVideo">
                          <button
                            className="download-btn"
                            onClick={() => downloadPlaylistVideo(showDetails.b2b_id, showDetails.videos[0].video_id, "videoFlag")}
                          >
                            Download Video
                          </button>
                        </div>
                      )}
                      {showDetails?.type === "VIDEO" && selectedVideoDetails?.video_id && (
                        <div className="downloadTypeVideo">
                          <button
                            className="download-btn"
                            onClick={() => downloadPlaylistVideo(showDetails.b2b_id, selectedVideoDetails.video_id, "videoFlag")}
                          >
                            Download Video
                          </button>
                        </div>
                      )}
                      {showDetails?.teaser_flag === 1 && showDetails?.teaser && (
                        <div className="downloadShowTrailer">
                          <button
                            className="download-btn"
                            onClick={() => downloadPlaylistVideo(showDetails.b2b_id, showDetails.show_id, "trailerFlag")}
                          >
                            Download Trailer
                          </button>
                        </div>
                      )}
                      {showDetails?.trailer_id && (
                        <div className="trailerDownload">
                          <button
                            className="download-btn"
                            onClick={() => downloadPlaylistVideo(showDetails.b2b_id, showDetails.trailer_id, "trailerOnlyFlag")}
                          >
                            Download Trailer
                          </button>
                        </div>
                      )}
                    </>
                  )}
                  {downloadB2bModal?.downloadProgress > 0 && downloadB2bModal?.downloadProgress < 100 && (
                    <div className="download-progress-container">
                      <div className="download-progress-bar">
                        <div
                          className="download-progress-bar-fill"
                          style={{ width: `${downloadB2bModal.downloadProgress}%` }}
                        />
                      </div>
                      <div className="download-progress-label">
                        {downloadB2bModal.downloadProgress}%
                      </div>
                    </div>
                  )}
                  {projectInfo?.projectConfig?.config?.SHOW_SHARE_BUTTON === "true" && (
                    <div className="share">
                      <button
                        className="shareButton"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsShareActive(!isShareActive);
                        }}
                      >
                        <ShareIcon />
                      </button>
                      <div className={isShareActive ? "active shareContainer" : "shareContainer"} ref={shareRef}>
                        <div className="facebookContainer" onClick={() => setIsShareActive(false)}>
                          <FacebookShareButton url={pageURL} quote={"Share"} className="facebook">
                            Facebook
                            <div className="icon">
                              <FacebookIcon />
                            </div>
                          </FacebookShareButton>
                        </div>
                        <div className="twitterContainer" onClick={() => setIsShareActive(false)}>
                          <TwitterShareButton url={pageURL} className="twitter">
                            Twitter
                            <div className="icon">
                              <TwitterIcon />
                            </div>
                          </TwitterShareButton>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="bottomVignette"></div>
          </div>
          {showDetails?.type === "ENDED" && (
            <div className="eventEndedOverlay">
              <h2><Translate textKey={'the_event_ended_message'} /></h2>
              <p onClick={watchVideoHandler}><Translate textKey={'click_here_to_watch'} /></p>
            </div>
          )}
          {showDetails?.type !== "ENDED" && (
            <div className="info">
              <div className="metaData">
                <div className="left">
                  <div className="top">
                    {showDetails?.schedule_time && showDetails?.type !== "ENDED" && (
                      <span className="duration">{convertDateAndTimeToLocal(showDetails?.schedule_time)}</span>
                    )}
                  </div>
                  {(showDetails?.description || showDetails?.free_event === true) && (
                    <div className="bottom">
                      {showDetails?.description && (
                        <p className="description">{parse(showDetails?.description?.split("\n")?.join("<br>"))}</p>
                      )}
                    </div>
                  )}
                </div>
                <div className="right">
                  {showDetails?.categories?.length > 0 && (
                    <div className="categories">
                      <span className="heading"><Translate textKey={'categories'} /></span>
                      {showDetails?.categories?.map((item, index) => (
                        <span className="category" onClick={() => navigate(`/category/${item?.key}?career=${item?.key}`)} key={index}>
                          {item?.category_name}
                          {index + 1 !== showDetails?.categories?.length && ","}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {Array.isArray(showDetails?.videos) && (showDetails?.videos.length > 1 || showDetails?.type === "SHOW") && (
            <div className="similiarShowsContainer">
              <h1 className="heading">{showDetails?.type === "PLAYLIST" ? "Playlist Videos" : "Episodes"}</h1>
              <div className="b2bCards">
                {showDetails.videos.map((item, idx) => {
                  let thumb = item?.thumbnail || item?.thumbnail_350_200 || item?.logo || item?.logo_thumb;
                  return (
                    <div className="b2bVideoCard" key={idx} onClick={() => playVideo(item)}>
                      {(item?.is_free_video === true || item?.free_video === true) && (
                        <div className="premiumStatus">
                          <div className="free">
                            <img src={require("../../assets/Images/free_icon.png")} alt="FreeIcon" />
                          </div>
                        </div>
                      )}
                      <div className="imageContainer">
                        <img
                          src={thumb}
                          alt="Thumbnail"
                        />
                        {item?.duration_text && (
                          <span className="duration">{item.duration_text}</span>
                        )}
                        {item?.duration && (
                          <span className="duration">{item.duration}</span>
                        )}
                        <div className="playIconContainer">
                          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5v14l11-7z" fill="#fff"/></svg>
                        </div>
                      </div>
                      <div className="metaInformation">
                        <h1 className="videoName" title={item?.video_title || item?.show_name}>{item?.video_title || item?.show_name}</h1>
                        <div className="extraInfo">
                          <div className="left">
                            {item?.rating && <span className="rating">{item.rating}</span>}
                            {item?.year && <span className="year">{item.year}</span>}
                          </div>
                        </div>
                        {item?.synopsis && (
                          <p className="description">
                            {item.synopsis.slice(0, 50)}
                            {item.synopsis.length > 50 && "..."}
                          </p>
                        )}
                        {item?.video_description && (
                          <p className="description">
                            {item.video_description.slice(0, 50)}
                            {item.video_description.length > 50 && "..."}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default B2BDetailsScreenModal;
